import { analytics, env, error, i18n, title, exp } from '../libs';
import { wrapBench } from '@tcc/stopwatch';

/**
 * This contains all the steps that need to be executed on boot
 */
export default [
  {
    name: 'env',
    installer: wrapBench('env', env)
  },
  {
    name: 'error',
    installer: wrapBench('error', error)
  },
  {
    name: 'experimental',
    installer: wrapBench('exp', exp)
  },
  {
    name: 'i18n',
    installer: wrapBench('i18n', i18n)
  },
  {
    name: 'title',
    installer: wrapBench('title', title)
  },
  {
    name: 'analytics',
    installer: wrapBench('analytics', analytics)
  }
];
